import { useEffect } from "react";
import { SidebarProvider } from "../context/SidebarContext";
import { useSidebar } from "../context/sidebar";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
import { useOnboardingTutorial } from "../lib/tours/onboarding/runOnboardingTutorial";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const { runIfNeeded } = useOnboardingTutorial();

  useEffect(() => {
    // Small delay so the tutorial's first popover appears once the
    // dashboard has visibly settled, not the instant the layout mounts.
    const timer = window.setTimeout(runIfNeeded, 600);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen xl:flex">
      <a
        href="#contenido-principal"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100000] focus:rounded-lg focus:bg-brand-500 focus:px-4 focus:py-3 focus:text-sm focus:font-medium focus:text-white focus:outline-hidden focus:ring-3 focus:ring-brand-500/30"
      >
        Saltar al contenido
      </a>
      <div>
        <AppSidebar />
        <Backdrop />
      </div>
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <AppHeader />
        <main id="contenido-principal" tabIndex={-1} className="p-4 mx-auto max-w-(--breakpoint-2xl) focus:outline-hidden md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
